define.alias("shared/components/shared/modal/navigation", "calendar/components/shared/modal/navigation");